var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuckItMeritBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "#EE8585",
    rx: 32.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M19.8 33.11a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC94B",
    d: "M19.8 31.84a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1EBE1",
    d: "m26.18 26.22-7.97.24s-2.89.09-4.74.09a6.434 6.434 0 0 0 6.33 5.29 6.43 6.43 0 0 0 6.38-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M16.3 26.19v.04a3.53 3.53 0 1 0 7.06 0c0-.03-.01-.05-.01-.08l-7.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3738",
    d: "M16.95 26.18v.03a2.88 2.88 0 0 0 5.76 0c0-.02-.01-.04-.01-.06l-5.75.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.83 27.68c.31.59.77 1.07 1.34 1.41.44-.51.84-1.14.74-1.68-.14-.75-1.33-.17-2.08.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M18.93 20.54c3.55-.53 6.17 2.67 6.44 1.64a6.436 6.436 0 0 0-12.01 3.22s2.01-4.34 5.57-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M13.47 26.55c.05.28.04.29.13.56l12.4-.07c.12-.37.13-.42.18-.82l-7.97.24s-2.88.1-4.74.09Z",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7921E",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.728,
    d: "M19.8 31.84a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88ZM13.4 26.12h12.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M44.49 33.11a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC94B",
    d: "M44.49 31.84a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1EBE1",
    d: "m50.87 26.22-7.97.24s-2.89.09-4.74.09a6.434 6.434 0 0 0 6.33 5.29 6.43 6.43 0 0 0 6.38-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M40.99 26.19v.04a3.53 3.53 0 1 0 7.06 0c0-.03-.01-.05-.01-.08l-7.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3738",
    d: "M41.64 26.18v.03a2.88 2.88 0 0 0 5.76 0c0-.02-.01-.04-.01-.06l-5.75.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.52 27.68c.31.59.77 1.07 1.34 1.41.44-.51.84-1.14.74-1.68-.14-.75-1.33-.17-2.08.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M43.62 20.54c3.55-.53 6.17 2.67 6.44 1.64a6.436 6.436 0 0 0-12.01 3.22s2.01-4.34 5.57-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M38.16 26.55c.05.28.04.29.13.56l12.4-.06c.12-.37.13-.42.18-.82l-7.97.24c0-.01-2.88.09-4.74.08Z",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7921E",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.728,
    d: "M44.49 31.84a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88ZM38.09 26.12h12.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3738",
    d: "M16.54 14.93c-.7.33-1.22 1.02-1.22 1.8 0 .57.33.95 1.66.16 2.65-1.57 4.27-1.13 5.27-1.11.96.03-.44-3.36-5.71-.85ZM46.43 14.93c.7.33 1.22 1.02 1.22 1.8 0 .57-.33.95-1.66.16-2.65-1.57-4.27-1.13-5.27-1.11-.95.03.44-3.36 5.71-.85Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M25.578 47.643c1.16-1.446 1.717-.944 1.717-.944s-.493-1.733.203-2.712c.697-.98 1.618-.933 2.456-.354.838.589.63-.728.35-.765-.28-.036-.357-1.955.72-2.25 1.075-.294 2.776.503 2.776.503s-.939-.657-.894-1.768c.045-1.11.818-1.661 2.027-1.768 1.208-.106 10.885 5.474 10.885 5.474s1.503.25 1.233 3.174l3.795 1.888c.657-1.009 1.407-1.769 2.072-1.388 0 0 1.26.023 1.564 1.03.261.856-.277.983.638 1.32l.088-.16s.422.204.996.486c1.405.361 3.25.726 3.184 1.737.01.01 0 .04-.009.08-.009.06-.038.131-.057.201-.587 1.728-4.765 10.766-4.91 11.088-.156.352-4.36-1.442-4.36-1.442l.076-.27c-.29-.017-.55.037-.748.2-1.058.894-4.52-.78-4.005-2.577.048-.16.125-.361.212-.573l-3.423-1.674s-.716 1.72-1.958 2.377c-1.24.657-2.43.003-3.287.925-.868.921-1.944 3.426-2.44 4.553-.494 1.127-2.497.194-3.006-.47-.509-.663-1.358-2.081.313-4.254 1.67-2.173 3.182-5.004 2.548-5.355-.625-.352-8.125-3.98-8.125-3.98s-1.782-.897-.631-2.332Z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC94B",
    d: "m48.302 44.125 5.322 3.029s.937 7.178-5.586 9.966l-5.26-2.95s-.827 1.742-2.129 2.37c-1.301.627-2.471-.107-3.4.796-.927.913-2.173 3.46-2.738 4.597-.564 1.138-2.549.085-3.028-.629-.48-.713-1.26-2.223.56-4.388 1.822-2.165 3.513-5.028 2.888-5.42-.626-.39-8.052-4.51-8.052-4.51s-1.764-.997-.503-2.434c1.26-1.438 1.808-.895 1.808-.895s-.415-1.814.342-2.795c.757-.98 1.698-.893 2.517-.244.82.65.68-.729.4-.775-.28-.047-.248-2.047.859-2.292 1.107-.245 2.799.652 2.799.652s-.92-.728-.805-1.88c.114-1.15.927-1.682 2.156-1.728 1.23-.047 10.775 6.185 10.775 6.185s1.504.32 1.075 3.345Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M35.993 35.41s-1.135-.364-1.575.342c.29-.754 1.015-1.124 2.024-1.167 1.23-.047 10.775 6.185 10.775 6.185s1.938.624 1.558 3.56l-1.328.867s.466-2.486-.394-3.225c-.86-.738-5.86-3.641-5.86-3.641l-5.2-2.92ZM37.74 41.758s-.275-1.056-1.273-1.653c-.988-.597-3.786-1.92-4.276-1.922l-.48-.004s.251-.593.57-.638c.32-.034 3.242.797 4.13 1.335.887.538 1.713 1.037 1.728 1.396.015.36-.259 1.544-.259 1.544M34.117 44.567s.031-.66-.9-1.428c-.93-.767-3.378-2.114-3.931-2.317-.553-.203-1.144.445-1.256.337-.121-.108 1.512-1.35 2.891-.69 1.38.662 3.485 1.764 3.726 2.63.242.868-.285 1.865-.285 1.865M32.449 47.69s-.352-.905-1.441-1.58c-1.08-.676-2.566-1.886-3.636-1.872-1.07.015-1.189.126-1.189.126s1.08-1.464 2.56-.744 4.147 1.914 4.093 2.345c-.054.43-.194 1.232-.194 1.232l-.032.59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEB540",
    d: "M45.971 47.047c1.439-.9 2.506-2.554 2.858-3.149-.007.17-.025.35-.052.541l5.32 2.968s.464 6.935-6.06 9.723L42.9 54.25c.045-1.091.432-2.817.269-3.745-.217-1.237 1.018-2.344 2.803-3.458ZM41.047 38.613s-.208 1.643-1.621 2.142c-1.413.5-.098.181-.098.181s-.062 2.761-2.985 2.58c0 0 .206 2.698-2.1 3.05 0 0-.225 3.263-1.786 3.184l-1.058-.596s1.05-.724 1.243-1.967c.194-1.232.33-1.474.33-1.474s.935-.393 1.43-1.52c.495-1.127.691-1.38.691-1.38s1.588.53 2.353-.531c.756-1.07.703-2 .703-2s1.772-.664 2.302-1.361c.55-.707.596-.308.596-.308Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M42.916 49.629s-.46-.804-1.329-1.372c-.676-.441-1.59-.76-2.736-.464-2.631.666-2.51-.726-.925-1.087 1.575-.362 3.5.733 3.5.733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7921E",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.727,
    d: "M47.527 45.246c1.883-2.076.633-4.279-1.02-5.217l-7.608-4.257M28.416 47.474l6.361 3.775M31.978 45.386l-3.255-1.826a1.792 1.792 0 0 0-2.431.683 1.792 1.792 0 0 0 .683 2.43L30.23 48.5a1.792 1.792 0 0 0 2.43-.683 1.79 1.79 0 0 0-.682-2.43ZM33.823 42.09l-3.255-1.825a1.792 1.792 0 0 0-2.43.682 1.792 1.792 0 0 0 .682 2.431l3.255 1.827a1.792 1.792 0 0 0 2.431-.683 1.792 1.792 0 0 0-.683-2.431ZM37.197 39.405l-3.255-1.826a1.792 1.792 0 0 0-2.43.683 1.792 1.792 0 0 0 .682 2.43l3.255 1.827a1.792 1.792 0 0 0 2.431-.683 1.792 1.792 0 0 0-.683-2.431Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7921E",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.727,
    d: "m40.117 36.385-3.255-1.826a1.792 1.792 0 0 0-2.431.683 1.792 1.792 0 0 0 .683 2.431l3.255 1.826a1.792 1.792 0 0 0 2.43-.683 1.801 1.801 0 0 0-.682-2.43ZM34.466 51.133c1.681.827-.57 2.248-2.812 5.858-2.241 3.601.382 4.536 1.268 4.954.885.418 1.516-.3 1.516-.3 1.377-2.46 3.077-5.413 4.7-5.165 2.085.322 3.38-2.275 3.38-2.275M32.017 45.306l2.348 1.318M33.995 42.188l2.348 1.319M37.117 39.366l2.348 1.319"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7921E",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.727,
    d: "M42.959 49.818a4.033 4.033 0 0 0-4.792-3.085 4.033 4.033 0 0 0-3.086 4.792M48.702 44.13l5.341 2.998M42.693 53.872l5.27 2.95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5DBD9",
    d: "M50.158 49.73s2.492-5.823 4.086-4.805c0 0 1.281.093 1.535 1.14.254 1.046-.536 1.017 1.142 1.614 1.678.598 4.766 1.116 3.299 2.856-1.457 1.74-4.776 10.706-5.657 10.647-.88-.058-3.574-2.541-4.703-1.666-1.128.875-4.554-1.029-3.929-2.867.615-1.839 4.227-6.918 4.227-6.918Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#72A09D",
    d: "M56.446 47.296s3.99 2.196 4.134 2.494c.134.298-5.52 11.176-5.695 11.528-.175.352-4.363-1.701-4.363-1.701s1.345-4.049 1.783-4.945c.458-.906 4.14-7.376 4.14-7.376Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M56.911 47.67c-1.678-.598-.888-.569-1.142-1.615-.254-1.047-1.535-1.14-1.535-1.14-1.584-1.018-4.086 4.806-4.086 4.806s-.57.808-1.295 1.888l.338-.145s-3.62 5.96-3.203 6.424c.416.464.41.675.813.179.403-.495 6.152-12.464 6.766-12.163.604.302 1.95.734 1.97 1.454.01.72-.633 1.309-.633 1.309s.839-.132 2.247.5c1.409.63 2.699 2.093 3.059 1.348a7.61 7.61 0 0 0 .378-.855c-.014-1.07-2.31-1.499-3.677-1.99Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6366",
    strokeMiterlimit: 10,
    strokeWidth: 0.887,
    d: "m52.755 45.005-6.706 12.202a.842.842 0 0 0 .366 1.165l2.537 1.256a.837.837 0 0 0 1.125-.385l5.956-12.132a.852.852 0 0 0-.254-1.046l-1.778-1.316a.84.84 0 0 0-1.246.256Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6366",
    strokeMiterlimit: 10,
    strokeWidth: 0.887,
    d: "m56.033 47.101 4.79 2.186L54.71 61.67l-4.633-2.437"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 14h43.57v49.82H13z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuckItMeritBadge);
export default __webpack_public_path__ + "static/media/suck-it-merit-badge.1c937f3d6484401979f16ca0ae6ea8a3.svg";
export { ForwardRef as ReactComponent };